import lodashDebounce from 'lodash/debounce';
import lodashGet from 'lodash/get';
import lodashSet from 'lodash/set';

var lodashWrapper = function lodashWrapper(fn) {
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return fn.apply(void 0, args);
  };
}; // Create our own API of function names. By simply wrapping some things, we can
// swap out or combine libraries or make our own utility functions transparently
// to the consumers of the library.


export var debounce = lodashDebounce;
export var get = lodashWrapper(lodashGet);
export var set = lodashWrapper(lodashSet);